//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'CDAI',
  data () {
    return {
      form: {
        watery: '',
        gender: '',
        difenoxate: '0',
        Arthritis: '0',
        Iritis: '0',
        erythema: '0',
        AnalFissure: '0',
        syrinx: '0',
        fever: '0',
        lump: '',
        c1: '',
        c2: '',
        c3: '',
        c4: '',
        c5: '',
        c6: '',
        c7: '',

        g1: '',
        g2: '',
        g3: '',
        g4: '',
        g5: '',
        g6: '',
        g7: '',

        hct: '',
        height: '',
        weight: '',
      },
      hasScore: false,
      disabled: false,
      dataList1: [
        {value: '1', name: '男'},
        {value: '0', name: '女'}
      ],
      dataList2: [
        {value: '0', name: '无'},
        {value: '20', name: '可疑'},
        {value: '50', name: '明确'}
      ],
      dataList3: [
        {value: '0', name: '0'},
        {value: '1', name: '1'},
        {value: '2', name: '2'},
        {value: '3', name: '3'}
      ],
      dataList4: [
        {value: '0', name: '0'},
        {value: '1', name: '1'},
        {value: '2', name: '2'},
        {value: '3', name: '3'}
      ],
      dataList5: [
        {value: '0', name: '0'},
        {value: '1', name: '1'},
        {value: '2', name: '2'},
        {value: '3', name: '3'}
      ],
      dataList6: [
        {value: '0', name: '0'},
        {value: '1', name: '1'},
        {value: '2', name: '2'},
        {value: '3', name: '3'}
      ],
      dataList7: [
        {value: '0', name: '0'},
        {value: '1', name: '1'},
        {value: '2', name: '2'},
        {value: '3', name: '3'}
      ],
      dataList8: [
        {value: '0', name: '0'},
        {value: '1', name: '1'},
        {value: '2', name: '2'},
        {value: '3', name: '3'}
      ],
      dataList9: [
        {value: '0', name: '0'},
        {value: '1', name: '1'},
        {value: '2', name: '2'},
        {value: '3', name: '3'}
      ],
      dataList10: [
        {value: '0', name: '0'},
        {value: '1', name: '1'},
        {value: '2', name: '2'},
        {value: '3', name: '3'},
        {value: '4', name: '4'}
      ],
      dataList11: [
        {value: '0', name: '0'},
        {value: '1', name: '1'},
        {value: '2', name: '2'},
        {value: '3', name: '3'},
        {value: '4', name: '4'}
      ],
      dataList12: [
        {value: '0', name: '0'},
        {value: '1', name: '1'},
        {value: '2', name: '2'},
        {value: '3', name: '3'},
        {value: '4', name: '4'}
      ],
      dataList13: [
        {value: '0', name: '0'},
        {value: '1', name: '1'},
        {value: '2', name: '2'},
        {value: '3', name: '3'},
        {value: '4', name: '4'}
      ],
      dataList14: [
        {value: '0', name: '0'},
        {value: '1', name: '1'},
        {value: '2', name: '2'},
        {value: '3', name: '3'},
        {value: '4', name: '4'}
      ],
      dataList15: [
        {value: '0', name: '0'},
        {value: '1', name: '1'},
        {value: '2', name: '2'},
        {value: '3', name: '3'},
        {value: '4', name: '4'}
      ],
      dataList16: [
        {value: '0', name: '0'},
        {value: '1', name: '1'},
        {value: '2', name: '2'},
        {value: '3', name: '3'},
        {value: '4', name: '4'}
      ],
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key] && key !== 'drop') {
            flag = false
          } else {
            if (form[key] === '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }

      if (!flag) {
        self.hasScore = false
        return '...'
      } else {
        console.log(form)
        // 体重偏差点
        let wdp = 100 * (1 - form.weight / (form.gender == '1' ? Math.pow(form.height, 2) * 22.1 : Math.pow(form.height, 2) * 20.8))
        wdp = wdp.toFixed(1)
        // 绝对血细胞比容偏差
        let ahd = (form.gender == '1' ? 1 : 0) * (47 - form.hct)
        ahd = ahd.toFixed(2)
        // 结果= 粪便计数系数+ 性别+使用地芬诺酯或洛哌丁胺治疗腹泻 + 关节炎或关节痛 + 虹膜炎或葡萄膜炎 + 结节性红斑、坏疽性脓皮病或口疮性口炎 + 肛裂，瘘管或脓肿 + 其他瘘管 + 发热+ 发现腹部肿块 +
        // + 7 天内腹痛等级（计算平均分）+ 7天内健康状况（计算平均分）+体重偏差点 + (6 * 绝对血细胞比容偏差)
        let result = form.watery * 14 + form.difenoxate * 30 + form.Arthritis * 20 + form.Iritis * 20 + form.erythema * 20 +
          form.AnalFissure * 20 + form.syrinx * 20 + form.fever * 20 + form.lump +
          ((form.c1 + form.c2 + form.c3 + form.c4 + form.c5 + form.c6 + form.c7) / 7) +
          ((form.g1 + form.g2 + form.g3 + form.g4 + form.g5 + form.g6 + form.g7) / 7) +
          Number(wdp) + Number((6 * ahd))
        self.hasScore = true
        return String(result.toFixed(2))
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/GIT/CDAI.vue